import WIDGETS from './widgets';

export default {
  name: 'exercise_details',
  spacing: 0,
	direction: 'column',
	widgets: [
		{ content: WIDGETS.GOBACKEXERCISE, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
		{ content: WIDGETS.UPDATEEXERCISE, breakpoints: { xs: 12, sm: 12 } },
	],
};
